import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Radium from 'radium';
import { connect } from 'react-redux';

import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';

import styles from './styles';

class TopbarButton extends Component {
  state = { imgIcon: this.props.icon };

  onMouseEnter = () => this.setState({ imgIcon: this.props.hoverIcon });

  onMouseLeave = () => this.setState({ imgIcon: this.props.icon });

  render() {
    const { route, action, style } = this.props;
    const imageButton = (
      <div style={styles.button} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <img height={30} src={this.state.imgIcon} alt="" />
      </div>
    );

    return (
      <div style={[styles.container, style]}>
        {action ? (
          <UTTouchableWithoutFeedback onClick={action}>{imageButton}</UTTouchableWithoutFeedback>
        ) : (
          <UTTouchableWithoutFeedback onClick={this.onRouteChange}>
            <Link to={route}>{imageButton}</Link>
          </UTTouchableWithoutFeedback>
        )}
      </div>
    );
  }
}

TopbarButton.propTypes = {
  icon: PropTypes.string.isRequired,
  hoverIcon: PropTypes.string.isRequired,
  route: PropTypes.string,
  action: PropTypes.func
};

export default connect()(Radium(TopbarButton));
